import HorecaBenefits from "@/components/sections/HorecaBenefits";
import ProductCarousel from "@/components/sections/ProductCarousel";
import Testimonials from "@/components/sections/Testimonials";
import FinalCTA from "@/components/sections/FinalCTA";
import { motion } from "framer-motion";
import { IMG } from "@/data/content";

export default function Horeca() {
  return (
    <div data-testid="page-horeca">
      <section className="relative py-24 md:py-32 overflow-hidden">
        <div className="absolute inset-0">
          <img src={IMG.croissantTray} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/95 via-black/85 to-black/75" />
        </div>
        <div className="relative z-10 max-w-5xl mx-auto container-px text-white">
          <motion.p initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="eyebrow text-gold">HoReCa</motion.p>
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="h-display text-4xl md:text-6xl mt-4 text-white">
            Furnizorul tău pentru <em className="text-gold not-italic">ritmul real</em> al unei bucătării.
          </motion.h1>
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.15 }} className="mt-6 text-base md:text-lg text-white/85 leading-relaxed max-w-2xl">
            Restaurante, cafenele, hoteluri, pizzerii, fast-food-uri, brutării și distribuitori — toți au ceva în comun: nevoia de produse care funcționează zi de zi.
          </motion.p>
        </div>
      </section>

      <HorecaBenefits />
      <ProductCarousel />
      <Testimonials />
      <FinalCTA />
    </div>
  );
}
